import Plaintiff from './Plaintiff';

export default Plaintiff;
